import {
  lowerHere,
  upperHere,
  numberHere,
  specialHere,
} from 'utils/helper';

const forgotSchema = {
  verificationCode: [{
    rule: 'required',
    error: 'Verification code is required',
  }],
  newPassword: [
    {
      rule: 'required',
      error: 'Password is required',
    },

    {
      isValid: (input) => {
        const text = input || '';
        if (input) {
          return lowerHere(text)
            ? true
            : 'Password must contain a lower case letter';
        }
        return true;
      },
    },
    {
      isValid: (input) => {
        const text = input || '';
        if (input) {
          return upperHere(text)
            ? true
            : 'Password must contain an upper case letter';
        }

        return true;
      },
    },
    {
      isValid: (input) => {
        const text = input || '';
        if (input) {
          return numberHere(text) ? true : 'Password must contain a number';
        }
        return true;
      },
    },
    {
      isValid: (input) => {
        const text = input || '';
        if (input) {
          return specialHere(text)
            ? true
            : 'Password must contain a special character';
        }
        return true;
      },
    },
    {
      rule: 'minLength',
      option: 8,
      error: 'Password must contain at least 8 characters',
    },
  ],
  confirmPassword: [
    {
      rule: 'isEqual',
      option: {
        match: 'newPassword',
      },
      error: 'Password should match',
    },
  ],
};

export default forgotSchema;
